exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.body-centered-window {\n    position: fixed;\n    inset: -9999px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n    background: rgba(0, 0, 0, 0.3);\n}\n", ""]);
